import React from 'react';
import PropTypes from 'prop-types';
import styles from './NewMyPropertyTeaser.less';
import tracking from '../../tracking/tracking.js';
import { CLAIM_PROPERTY, PROPERTY_BOOK_V2 } from '../../tracking/trackingNaming.js';
import MyPropertyIcon from './Table/MyPropertyIcon';
import createRealestate from '../../assets/images/icon-create-realestate.svg';
import analytics from '../../assets/images/icon-analytics.svg';
import sellRealestate from '../../assets/images/icon-start-sell.svg';
import MyPropertyDescription from './Table/MyPropertyDescription';

const MyPropertyTeaser = ({ onButtonClicked, title, description, isHomePage, trackingAction }) => {
  const handleButtonClick = () => {
    tracking.overwriteTrackingEventContext('overview');
    tracking.report(CLAIM_PROPERTY, trackingAction);
    tracking.revertTrackingEventContext();
    onButtonClicked();
  };

  return (
    <div data-identifier="my-property-widget" className={`grid ${styles.myPropertyContainer}`}>
      <div className={`grid-item one-whole ${styles.titleContainer}`}>
        <h2 className={styles.headline}>{title}</h2>
        <p className={isHomePage ? `${styles.descriptionHomepage}` : '' } >{description}</p>
      </div>
      <div className={`grid-item one-whole `}>
        <div data-qa="nmpt-headline" className={`padding-vertical-m ${styles.myPropertyFunctionalityHeader}`}>
          So einfach funktioniert&apos;s
        </div>
        <div className={`grid-item ${isHomePage ? `one-whole` : `grid-flex ${styles.myPropertyTable}`}`}>
          <div
            {...(isHomePage ? { className: `grid-item palm-one-whole lap-one-half desk-one-third ${styles.wrapperSteps}` } : {})}>
            <MyPropertyIcon url={createRealestate} alt="create realestate" isHomePage={isHomePage} />
            <MyPropertyDescription
              header="1. Sie legen Ihre Immobilie an"
              text="Bereits wenige Angaben zu Ihrer Immobilie genügen."
            />
          </div>
          <div
            {...(isHomePage ? { className: `grid-item palm-one-whole lap-one-half desk-one-third ${styles.wrapperSteps}` } : {})}>
            <MyPropertyIcon url={analytics} alt="analytics" isHomePage={isHomePage} />
            <MyPropertyDescription
              header="2. Behalten Sie den Überblick"
              text="Im Eigentümerbereich können Sie alle Immobiliendaten einsehen."
            />
          </div>
          <div
            {...(isHomePage ? { className: `grid-item palm-one-whole lap-one-whole desk-one-third ${styles.wrapperSteps} ${styles.lastStep} ` } : {})}>
            <MyPropertyIcon url={sellRealestate} alt="sell realestate" isHomePage={isHomePage} />
            <MyPropertyDescription
              header="3. In den Verkauf starten"
              text="Wählen Sie die passende Verkaufsstrategie für Ihre Immobilie."
            />
          </div>
        </div>

        <div className={`grid-item one-whole align-left ${styles.myPropertyButton} grid-align-end`}>
          <button
            id="my-property-widget-button"
            type="button"
            className="button-secondary margin-top-l"
            onClick={handleButtonClick}
          >
            Zum Eigentümerbereich
          </button>
        </div>
      </div>
    </div>
  );
}

MyPropertyTeaser.propTypes = {
  onButtonClicked: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  isHomePage: PropTypes.bool,
  trackingAction: PropTypes.string,
};

MyPropertyTeaser.defaultProps = {
  title: "Behalten Sie Ihre Immobilie immer im Blick",
  description: "Im neuen Eigentümerbereich können Sie Ihre Immobilie anlegen und so die aktuelle Marktentwicklung in Ihrer Region beobachten sowie Preisupdates verfolgen.",
  isHomePage: false,
  trackingAction: PROPERTY_BOOK_V2,
};

export default MyPropertyTeaser;
